




































import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class TransferItem extends Vue {
    @Prop(Object) private data!: TransferItemData
    @Prop(String) private sym!: string

    get isIn() { return this.data.owner === this.data.to }
    get opposite() { return this.isIn ? this.data.from : this.data.to }
}
